exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width:768px){.quiz .btn{width:auto!important}}.quiz__item{margin:0 auto;text-align:left;max-width:-moz-max-content;max-width:max-content}.quiz .radio{display:flex;margin:.25rem 0}.quiz .step-budzhet .filter__item{margin-bottom:.5rem}.quiz .input__field--search{margin:1rem 0}.quiz .swiper-slide{flex-direction:column}", ""]);

// exports
